<dv-dialog-content>
  <dv-dynamic-form
    [elements]="upperFormElements | translateElements"
    [formGroup]="formGroup">
  </dv-dynamic-form>
  @if (showResetQuantityBtn) {
    <div class="reset-quantity-btn" (click)="onResetQuantityClicked()">
      <span class="dv-icons">restore</span
      ><span class="reset-quantity-btn__text">{{
        'ExpenseEditModal.ResetQuantity' | translate
      }}</span>
    </div>
  }

  <dv-dynamic-form
    [elements]="lowerFormElements | translateElements"
    [formGroup]="formGroup">
  </dv-dynamic-form>
  <dv-button footer-right (click)="cancel()">
    {{ 'General.Cancel' | translate }}
  </dv-button>
  <dv-button
    footer-right
    color="secondary"
    (click)="performSave()"
    [disabled]="!formGroup.valid || !formGroup.dirty">
    {{
      (data.TripExpenseID === 0 ? 'General.Add' : 'General.Save') | translate
    }}
  </dv-button>
</dv-dialog-content>
